<template>
  <v-flex>
    <v-data-table
      :headers="headers"
      :items="invoices"
      v-model="selected"
      :loading="isLoading"
      :rows-per-page-items="[15]"
      :pagination.sync="pagination"
      :total-items="paginationTotal"
    >
      <template
        slot="items"
        slot-scope="{item}">
        <tr @click="downloadInvoice(item)">
          <td>{{ item.invoice_number }}</td>
          <td>{{ formatDate(item.date_create) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import PaginationApi from '@/api/PaginationApi'

import { mapGetters } from 'vuex'
import InvoicesApi from '@/api/InvoicesApi'

export default {
  name: 'InvoicesOverview',
  data () {
    return {
      selected: [],
      invoices: [],
      isLoading: false,
      pagination: null,
      paginationTotal: null,
      headers: [
        { text: this.$t('invoice_number'), sortable: false },
        { text: this.$t('date_create'), sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters('user', ['getUser']),
    url () {
      return this.$can('read', 'AllInvoices')
        ? `/users/${this.currentUser.id}/invoices`
        : `/users/${this.getUser.id}/invoices`
    }
  },
  methods: {
    formatDate (date) {
      return this.$moment(date).format('DD.MM.YYYY')
    },
    async getPaginatedData () {
      this.isLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, [`page=${this.pagination.page}`])
        this.invoices = response.data
        this.paginationTotal = response.total
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    },

    downloadInvoice (item) {
      const { id, user_id, invoice_number, date_create } = item
      const fileName = `${id}-${user_id}-${invoice_number}-${date_create}.pdf`
      return InvoicesApi.downloadLinkForInvoice(id, fileName)
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler: 'getPaginatedData'
    },
    search: 'searchEmployee'
  },
  i18n: {
    messages: {
      de: {
        invoice_number: 'Rechnung',
        date_create: 'Datum'
      },
      en: {
        invoice_number: 'Invoice',
        date_create: 'Date'
      },
      tr: {
        invoice_number: 'Fatura',
        date_create: 'Tarih'
      },
      ru: {
        invoice_number: 'Инвойсов',
        date_create: 'дата'
      }
    }
  }
}
</script>
